import Loadable from "app/components/Loadable";
import { lazy } from "react";

const WelcomePage = Loadable(lazy(() => import("./WelcomePage")));

const welcomeRoutes = [
  { path: "welcome", element: <WelcomePage /> },
];

export default welcomeRoutes;